/* istanbul ignore file */
interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  text: string;
  name: string;
  required?: boolean;
}

const Label: React.FC<LabelProps> = ({ text, name, required = false, ...rest }: LabelProps) => (
  <label htmlFor={name} className="text-left mb-2 block text-xs font-medium text-placeholder uppercase" {...rest}>
    {text}
    {required && <>*</>}
  </label>
);

export default Label;
